import {Component} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';

export class ConfirmModal extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onConfirm();
  }

  render() {
    return (
      <Modal
        defaultStyles={{
          overlay: {
            backgroundColor: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1
          },
          content: {
            backgroundColor: '#fff',
            borderRadius: 4,
            boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 32px 0px',
            minWidth: 300,
            outline: 0,
            padding: 20,
            position: 'relative'
          }
        }}
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onClose}
        ariaHideApp={false}
        shouldCloseOnOverlayClick
      >
        <div style={{textAlign: 'center'}}>
          <form onSubmit={this.handleSubmit}>
            <strong
              data-id="content"
              className="py-4"
            >
              {this.props.content}
            </strong>
            <div
              data-id="warning"
              className="pt-4 information"
            >
              {this.props.warning}
            </div>
            <div className="actions col-12 inline-container space-between">
              <button
                type="button"
                className="large secondary inline-container"
                onClick={this.props.onClose}
                data-id="cancel"
              >
                <Icon icon="go-back"/>
                <Translate value="action.cancel"/>
              </button>
              <button
                className="large primary inline-container"
                id="submit"
                type="submit"
              >
                <Icon icon="check"/>
                <Translate value="action.confirm"/>
              </button>
            </div>
          </form>
        </div>
      </Modal>
    );
  }
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
  warning: PropTypes.object.isRequired
};

export default ConfirmModal;
